var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 5.12836H27.1739V6.53079H35V5.12836Z",
    fill: "#1A1F36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1739 8.16696H35V9.5694H27.1739V8.16696Z",
    fill: "#1A1F36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5968 11.2056H27.1739V12.608H28.5968V11.2056Z",
    fill: "#1A1F36"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3755 11.2056H31.7984V12.608H30.3755V11.2056Z",
    fill: "#1A1F36"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35 11.2056H33.5771V12.608H35V11.2056Z",
    fill: "#1A1F36"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1818 24.6456V33.4692H17.8063V28.9697H19.2292V33.4692H20.7708V24.6456H22.1937V33.4692H26.8775V28.9697H28.3004V33.4692H29.8419V24.6456H31.2648V33.4692H35V34.8717H5V33.4692H8.79447V28.9697H10.2174V33.4692H11.7589V24.6456H13.1818Z",
    fill: "#1A1F36"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3886 16.7754C14.7348 17.2949 13.9383 17.6468 13.0661 17.765V19.765C14.4935 19.6303 15.7913 19.0581 16.8198 18.186L15.3886 16.7754Z",
    fill: "#0096E9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6478 17.3493C18.601 16.2011 19.1728 14.7334 19.1728 13.1341C19.1728 11.511 18.5839 10.0236 17.6052 8.86793L16.1715 10.281C16.7894 11.0704 17.157 12.0599 17.157 13.1341C17.157 14.1844 16.8055 15.1539 16.2122 15.9344L17.6478 17.3493Z",
    fill: "#0096E9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.336 9.45159L16.7688 8.03944C15.7486 7.19138 14.47 6.63562 13.0661 6.50314V8.50314C13.915 8.6182 14.6923 8.95469 15.336 9.45159Z",
    fill: "#0096E9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8803 8.48856V6.49298C8.6126 6.74451 5.99741 9.28648 5.68609 12.4913H7.71531C8.0092 10.385 9.72682 8.72619 11.8803 8.48856Z",
    fill: "#0096E9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8803 17.7796C9.68714 17.5376 7.94606 15.8216 7.70052 13.66H5.67578C5.93408 16.9197 8.57298 19.5206 11.8803 19.7752V17.7796Z",
    fill: "#0096E9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9119 13.1341C15.9119 15.0382 14.3457 16.5817 12.4138 16.5817C10.4819 16.5817 8.91581 15.0382 8.91581 13.1341C8.91581 11.23 10.4819 9.68644 12.4138 9.68644C14.3457 9.68644 15.9119 11.23 15.9119 13.1341Z",
    fill: "#0096E9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8292 15.1834L31.3269 18.6352L29.074 16.4147L24.4494 20.9726L22.3151 18.869L19.2363 21.9034L18.3978 21.077L22.3151 17.2162L24.4494 19.3199L29.074 14.7619L31.3269 16.9825L33.9907 14.357L34.8292 15.1834Z",
    fill: "#0096E9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.9b70d116866df77f520d7e45b5de7a8b.svg";
export { ForwardRef as ReactComponent };